import { useTranslation } from 'react-i18next';
import { withProviders } from '../../../providers/with-providers';
import { Icon } from '../../foundations';
import { Text } from '../../foundations';
import { clsx } from 'clsx';
import React from 'react';
import styles from './AlertUpgradingAvios.module.css';

// Types and Iterfaces
type AlertType = 'aler_info' | 'alert_warning' | 'alert_error';
export type AlertUpgradingAviosProps = {
	type?: AlertType;
	id?: string;
};

const Component = (props: AlertUpgradingAviosProps) => {
	const { t } = useTranslation(['alert-upgrading-avios', 'common']);
	const { id, type = 'alert_warning' } = props;
	const generateIdentifier = React.useId();
	const identifier = id ?? generateIdentifier;
	return (
		<section
			role="alert"
			className={clsx(styles.alert_container, styles[type])}
			id={`${identifier}-alert-upgrading-avios`}
		>
			<header className={styles.alert_header}>
				<Icon name="alertas" className={styles.alert_icon} />
				<Text className={clsx(styles.alert_title, styles[type])} as="h3" font="iberia-headline" size="xs-regular">
					{t('common:IMPORTANT_ANNOUNCEMENT')}
				</Text>
			</header>
			<Text font="verdana" size="lg-regular" className={styles.alert_description}>
				{t('MMB_UPGRADING_AVIOS_ALERT_INFO_2')}
			</Text>
		</section>
	);
};

export const AlertUpgradingAvios = withProviders(Component);
